import classNames from "@calcom/lib/classNames";

export default function Logo({
  small,
  icon,
  inline = true,
  className,
  src = "/api/logo",
}: {
  small?: boolean;
  icon?: boolean;
  inline?: boolean;
  className?: string;
  src?: string;
}) {
  return (
    <h3 className={classNames("logo", inline && "inline", className)}>
      <strong>
        {/* NELLIE CUSTOM CODE */}
        {icon ? (
          <img className="mx-auto w-9 dark:invert" alt="Cal" title="Cal" src="/NellieLogoBG.png" />
        ) : (
          <img
            className={classNames(small ? "h-4 w-auto" : "h-5 w-auto", "dark:invert")}
            alt="Cal"
            title="Cal"
            src="/NellieLogoH.svg"
          />
        )}
      </strong>
    </h3>
  );
}
